import { lsGet, lsSet } from '@/lib/utils';
import i18n from '@/plugins/i18n';
import { LiquiditySelection } from '@/lib/utils/balancer/helpers/sor/sorManager';
import LS_KEYS from '@/constants/local-storage.keys';

export enum TradeInterface {
  GNOSIS = 'gnosis',
  BALANCER = 'balancer',
}

export interface AppState {
  loading: boolean;
  locale: string;
  tradeLiquidity: LiquiditySelection;
  tradeInterface: TradeInterface;
}

const state: AppState = {
  loading: true,
  locale: lsGet('app.locale', 'en-US'),
  tradeLiquidity: lsGet(LS_KEYS.App.TradeLiquidity, LiquiditySelection.Best),
  tradeInterface: lsGet(LS_KEYS.App.TradeInterface, TradeInterface.BALANCER),
};

const actions = {
  init: async ({ commit, dispatch }) => {
    try {
      // Fetch onsen data
      await dispatch('acryptos/getOnsen', [], { root: true });

      // Fetch init data
      await dispatch('market/getGasPrice', [], { root: true });

      // Fetch initial trade tokens
      dispatch('trade/init', null, { root: true });

      commit('setLoading', false);
    } catch (error) {
      console.error('Failed to initialize app', error);
    }
  },
};

const mutations = {
  setLoading(state: AppState, val: AppState['loading']) {
    state.loading = val;
  },

  setLocale(state: AppState, locale: AppState['locale']) {
    state.locale = locale;
    lsSet('app.locale', locale);
    i18n.global.locale = locale;
  },

  setTradeLiquidity(state: AppState, tradeLiquidity: LiquiditySelection) {
    state.tradeLiquidity = tradeLiquidity;
    lsSet(LS_KEYS.App.TradeLiquidity, state.tradeLiquidity);
  },

  setTradeInterface(
    state: AppState,
    tradeInterface: AppState['tradeInterface']
  ) {
    state.tradeInterface = tradeInterface;
    lsSet(LS_KEYS.App.TradeInterface, state.tradeInterface);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
